import './HomeButtons.scss';

import { faBuilding, faLightbulbOn } from '@fortawesome/pro-solid-svg-icons';

import { AccountType, CategoryType } from 'eve-account-client';
import { EveRoutes } from '@ver-uds/e-verify';
import React from 'react';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import HomeButton from './HomeButton';
import { useAccount } from '../../../context/Account/AccountContext';
import CreateCaseButton from './CreateCaseButton/CreateCaseButton';

export interface HomeButtonsProps {
  createCaseModal: boolean;
}

const HomeButtons = ({ createCaseModal }: HomeButtonsProps): JSX.Element => {
  const { type, companyInfo } = useAccount();

  return (
    <div className="home-button-container margin-top-2">
      {type !== AccountType.CORPORATE ? (
        <>
          <CreateCaseButton
            createCaseModal={createCaseModal}
            isFederalContractor={companyInfo.employerCategory?.category === CategoryType.FEDERALCONTRACTOR}
          />
          <HomeButton link={EveRoutes.CASES_VIEW} svg={faSearch} linkText="Search Cases" />
        </>
      ) : (
        <HomeButton
          link={EveRoutes.CORPORATE_COMPANY_LOCATIONS_VIEW}
          svg={faBuilding}
          linkText="Manage Company Locations"
        />
      )}
      <HomeButton link={EveRoutes.RESOURCES_VIEW} svg={faLightbulbOn} linkText="View Resources" />
      <HomeButton link={EveRoutes.RESOURCES_CONTACT_US} svg={faEnvelopeOpenText} linkText="Contact Us" />
    </div>
  );
};

export default HomeButtons;
